export default function isNumeric(str) {
    return /^\d+$/.test(str);
}